import Changes from "components/CompanyDashboard/MaintainYourCompany/Changes";
import TransactionEditContext from "context/TransactionEditContext";
import React, { useEffect, useState } from "react";
import OfficialsShareholdersAuthorisedPersons from "components/CompanyDashboard/MaintainYourCompany/Changes/OfficialsShareholdersAuthorisedPersons";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getCompany } from "state/slices/company";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import { getTransactionChangeByIdAsync } from "state/slices/initiateTransactionChange";
import AllotmentOfShares from "components/CompanyDashboard/MaintainYourCompany/Changes/ShareCapital/AllotmentOfShares";

const TransactionEdit = () => {
  const { trxId, companyId } = useParams();
  const [transactionToEdit, setTransactionToEdit] = useState("");
  const [changeOfParticularsInfoEdit, setChangeOfParticularsInfoEdit] =
    useState({
      selectedValueTypeEdit: "",
    });

  const dispatch = useDispatch();
  const isInTransactionEditContext = true;

  useEffect(() => {
    dispatch(getCompany({ id: companyId }));
  }, [companyId]);

  useEffect(async () => {
    if (!transactionToEdit) {
      const response = await dispatch(getTransactionChangeByIdAsync({ trxId }));
      if (response.payload.status) {
        setTransactionToEdit(response.payload.retrievedTransactions);
      }
    }
  }, [trxId]);

  useEffect(() => {
    if (transactionToEdit?.trxRef) {
      window.localStorage.setItem("trxRef", transactionToEdit.trxRef);
    }
  }, [transactionToEdit]);
  return (
    <div>
      <TransactionEditContext.Provider
        value={{
          isInTransactionEditContext,
          changeOfParticularsInfoEdit,
          setChangeOfParticularsInfoEdit,
          transactionToEdit,
          setTransactionToEdit,
        }}
      >
        <CompanyDashboardWrapper>
          {transactionToEdit && (
            <div>
              {transactionToEdit?.officials?.length > 0 ? (
                <OfficialsShareholdersAuthorisedPersons
                  official={transactionToEdit.officials[0]}
                  trxRef={transactionToEdit.trxRef}
                  changeType={transactionToEdit.changeType}
                />
              ) : transactionToEdit?.authorizations?.length > 0 ? (
                <AllotmentOfShares typeOfChange={"authorization"} />
              ) : null}
            </div>
          )}
        </CompanyDashboardWrapper>
      </TransactionEditContext.Provider>
    </div>
  );
};

export default TransactionEdit;
